"use strict";

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { Fields, System } from "Constants/objects";
import { Model } from "Model";
import { Collection } from "Collection";
import { user } from "Models/UserModel";
import { D5TableConstants } from "Constants/Table/D5TableConstants";
import { formEditTableFormShowTable } from "Actions/Forms/FormEditTableActions";
import { formEditUpdateSubForm } from "Actions/Forms/FormEditActions";
import { tbButtonsToggleAttrs, tbSetDefaultButtonsState, toolbarTableFormButtonsDisabling, toolbarTableSetObjectName } from "Actions/Table/TableToolBarActions";
import { sideDrawerListItemActivate } from 'Actions/SideDrawerListActions';
import { showSnackBar } from "Actions/D5SnackbarsActions";
import { Messages } from "Messages";
import { changeDocumentTitle, loadForm } from "Actions/ApplicationActions";
import { TableToolBarConstants } from "Constants/Table/TableToolBarConstants";
import router, { createEditUrl } from 'Router';
import { loadFilterFields, loadFormFields, loadFormFilterFieldEvents, loadFormGroups, loadFormMetadata, loadObjectData, loadUserFunctions } from "D5Utils/common_requests";
import { sharedData } from 'SharedData';
import FormStore from "Stores/Forms/FormStore";
import Configurator from "Stores/Table/core/table/Configurator";
import { CustomLoader } from "D5Utils/CustomLoader";
import { d5TableFilterSaved, updateLayoutFilters } from "Actions/Table/D5TableActions";
import { createGuid, createTableID, getAddSSFilter, getSSTableCols, isEmptyObject, isEmptyValue, setAddSSFilter, setSSTableCols } from "D5Utils/functions";
import { FormEditConstants } from "Constants/Forms/FormEditConstants";

var D5TableStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(D5TableStoreClass, _StoreClass);

  /**
   * @type {FormEditStore}
   * @private
   */

  /**
   * @type {Configurator}
   */
  function D5TableStoreClass() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        instance = _ref.instance,
        formUUID = _ref.formUUID,
        parentFormID = _ref.parentFormID,
        parentUUID = _ref.parentUUID,
        viewSource = _ref.viewSource,
        formID = _ref.formID,
        filtersData = _ref.filtersData,
        popupInst = _ref.popupInst,
        requestColumns = _ref.requestColumns,
        tableData = _ref.tableData,
        relationType = _ref.relationType,
        masterObjKeyFieldName = _ref.masterObjKeyFieldName,
        detailObjKeyFieldName = _ref.detailObjKeyFieldName,
        owner = _ref.owner,
        _ref$formFilters = _ref.formFilters,
        formFilters = _ref$formFilters === void 0 ? [] : _ref$formFilters,
        _ref$dataContextMenu = _ref.dataContextMenu,
        dataContextMenu = _ref$dataContextMenu === void 0 ? {} : _ref$dataContextMenu;

    _classCallCheck(this, D5TableStoreClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(D5TableStoreClass).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_tableInstance", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_objectName", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_filtersData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_formID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_formUUID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_parentFormID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popupInst", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "viewSource", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "requestColumns", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tableData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_parentUUID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_masterObjKeyFieldName", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_detailObjKeyFieldName", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_formFilters", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_owner", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "configurator", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dataContextMenu", {});

    _this._tableInstance = instance;
    _this._formUUID = formUUID;
    _this._parentFormID = parentFormID;
    _this._formID = formID;
    _this._filtersData = filtersData;
    _this.popupInst = popupInst;
    _this.viewSource = viewSource;
    _this.requestColumns = requestColumns;
    _this.tableData = tableData;
    _this.relationType = relationType;
    _this._parentUUID = parentUUID;
    _this._masterObjKeyFieldName = masterObjKeyFieldName;
    _this._detailObjKeyFieldName = detailObjKeyFieldName;
    _this._owner = owner;
    _this._formFilters = formFilters;
    _this.dataContextMenu = dataContextMenu;
    _this.cancelRowChanges = _this.cancelRowChanges.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.saveRowChanges = _this.saveRowChanges.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.initTable();

    _this.dispatcherToken = AppDispatcher.register(function (action) {
      switch (action.actionType) {
        case D5TableConstants.D5_TABLE_FILTER_SAVED:
          if (action.formUUID !== _this._formUUID) {
            return;
          }

          _this.onFilterSaved(action);

          break;

        case D5TableConstants.D5_TABLE_USER_EVENT:
          var _action$options = action.options,
              props = _action$options.props,
              UUID = _action$options.formUUID;

          if (_this._formUUID === UUID) {
            _this.configurator.updateUserEvent(action.options).then(function () {
              var rowIndex = action.options.rowIndex;

              if (_this.configurator.viewChanged && rowIndex !== -1) {
                _this.configurator.instance().repaintRows([rowIndex]);

                _this.configurator.viewChanged = false;
              }

              if (props.filter
              /*&& props.filter.isChanged*/
              ) {
                  if (_this.configurator.inlineEditing()) {
                    console.warn(Messages.Warning.ChangeFilterInUserScript);
                    return true;
                  }

                  _this.saveFilter(props.filter.filter.lsColumns, props.filter.filter.addFilter);
                }
            });
          }

          break;

        case D5TableConstants.D5_TABLE_FORM_DESTROY_TABLE:
          setTimeout(function () {
            formEditTableFormShowTable(false, _this._formUUID);
          });
          break;

        case D5TableConstants.D5_TABLE_FORM_REFRESH:
          if (action.formUUID === _this._formUUID) {
            if (_this.configurator.isNestedObject()) {
              _this.tableInstance().refresh();
            } else {
              _this.refreshTable();
            }
          }

          break;

        case TableToolBarConstants.TOOLBAR_TABLE_EDIT_BTN_CLICKED:
          if (action.options.UUID === _this._formUUID) _this.editButtonEvent(action.options);
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_SHOW_FILTER_BTN_CLICKED:
          if (action.options.formUUID === _this._formUUID) _this.showHeaderFilterBtnClicked(action.options);
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_SELECTION_BTN_CLICKED:
          if (action.options.formUUID === _this._formUUID) _this.selectionClicked(action.options);
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_COLUMN_CHOOSER_BTN_CLICKED:
          if (action.options.formUUID === _this._formUUID) _this.showColumnChooserClicked();
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_SHOW_FILTER_MODAL_CLICKED:
          if (action.options.formUUID === _this._formUUID) _this.showTableModalFilter();
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_DELETE_ROWS_CLICKED:
          if (action.options.formUUID === _this._formUUID) {
            _this.deleteRows(_this.getKeysAfterClick(action.options));
          }

          break;

        case TableToolBarConstants.TOOLBAR_TABLE_GOTO_CLICKED:
          var _action$options2 = action.options,
              e = _action$options2.e,
              _formUUID = _action$options2.formUUID;

          if (_formUUID === _this._formUUID) {
            _this.gotoClicked(e, action.options);
          }

          break;

        case TableToolBarConstants.TOOLBAR_TABLE_REPORT_CLICKED:
          if (action.options.formUUID === _this._formUUID) {
            _this.reportClicked(action.options);
          }

          break;

        case TableToolBarConstants.TOOLBAR_TABLE_RESET_TABLE_SETTINGS:
          if (action.options.formUUID === _this._formUUID) {
            _this.configurator.resetSettings();

            updateLayoutFilters(_this._formUUID, System.FILTER_SENDERS.TABLE);

            _this.refreshTable();
          }

          break;

        case TableToolBarConstants.TOOLBAR_TABLE_CLEAR_QUICK_FILTERS:
          if (action.options.formUUID === _this._formUUID) _this.clearQuickFilters();
          break;

        case D5TableConstants.D5_TABLE_UPDATE_FORM_UUID:
          if (action.formUUID !== _this._formUUID) {
            _this._formUUID = action.nextFormUUID;
          }

          break;

        case D5TableConstants.D5_TABLE_FOCUS_LAST_ROW:
          _this.focusRowAfterEdit(action.options);

          break;

        case D5TableConstants.D5_TABLE_FOCUS_LAST_ROW_FULL:
          _this.focusRowAfterFullEdit(action.rowID);

          break;

        case D5TableConstants.D5_TABLE_ON_MASTER_CHANGED:
          if (_this._formID === action.options.formID) {
            _this.updateFilter(action.options);
          }

          break;

        case D5TableConstants.D5_TABLE_UPDATE_FILTER_SUBFORM:
          if (_this._parentUUID === action.formUUID) _this.configurator.updateFilterForSubForm(action.fieldsData);
          break;

        case D5TableConstants.D5_TABLE_EXPORT:
          if (_this._formUUID === action.formUUID) {
            _this.configurator.exportToXls(action.exportSelected);
          }

          break;

        case FormEditConstants.FORM_EDIT_SUBMITED:
          if (_this._formUUID === action.formUUID) _this.refreshTableAfterSubmittedForm(action);
          break;

        default:
          return true;
      }
    });
    return _this;
  }

  _createClass(D5TableStoreClass, [{
    key: "reportClicked",
    value: function reportClicked(options) {
      this.getReport(options).then(function (data) {
        if (typeof data === 'string') {
          var newWin = window.open();
          newWin.document.location = data;
        } else {
          loadForm({
            formID: data.actionFormID,
            viewMode: System.VIEW_MODE.MODAL,
            type: System.FORM_TYPE.REPORT,
            additionalData: data
          });
        }
      });
    }
  }, {
    key: "gotoClicked",
    value: function gotoClicked(e, options) {
      var _this2 = this;

      this.prepareGoTo(options).then(function (_ref2) {
        var formID = _ref2.formID,
            type = _ref2.type;

        if (!_this2.shouldOpenInNewAfterClick(e)) {
          router.navigateTo(options.url);
          return;
        }

        loadForm({
          formID: formID,
          type: type,
          parentUUID: _this2._formUUID,
          newLocation: document.location.origin + document.location.pathname + options.url,
          afterChildClose: _this2.afterChildClose.bind(_this2),
          viewMode: System.VIEW_MODE.IN_NEW_WINDOW
        });
      });
    }
  }, {
    key: "focusRowAfterEdit",
    value: function focusRowAfterEdit(_ref3) {
      var _this3 = this;

      var focusID = _ref3.focusID;
      this.tableInstance().refresh();
      setTimeout(function () {
        var index = _this3.tableInstance().getRowIndexByKey(focusID);

        if (index === -1) index = _this3.configurator.currentRowIndex;
        if (index != null) _this3.focusRowAfterModalEdit(index);
      }, 1000);
    }
  }, {
    key: "focusRowAfterModalEdit",
    value: function focusRowAfterModalEdit(index) {
      this.configurator.currentRowIndex = index;
      var key = this.tableInstance().getKeyByRowIndex(index);

      if (!this.tableInstance().getSelectedRowKeys().includes(key)) {
        this.tableInstance().selectRowsByIndexes([index]);
      }

      var cell = this.tableInstance().getCellElement(index, 0);
      this.tableInstance().focus(cell);
    }
  }, {
    key: "focusRowAfterFullEdit",
    value: function focusRowAfterFullEdit(index) {
      var key = this.tableInstance().getRowIndexByKey(Number(index));
      var cell = this.tableInstance().getCellElement(key, 0);

      if (key > -1 && index) {
        this.configurator.currentRowIndex = key;
        this.tableInstance().selectRowsByIndexes([key]);
        this.tableInstance().focus(cell);
        sharedData.lastRowIndex = null;
      }
    }
  }, {
    key: "updateFilter",
    value: function updateFilter() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          filter = _ref4.filter;

      var _System$TOOLBAR_BTN_C = System.TOOLBAR_BTN_CLASSES,
          SELECT = _System$TOOLBAR_BTN_C.SELECT,
          SEARCH = _System$TOOLBAR_BTN_C.SEARCH,
          ADD = _System$TOOLBAR_BTN_C.ADD,
          REFRESH = _System$TOOLBAR_BTN_C.REFRESH,
          EXPORT = _System$TOOLBAR_BTN_C.EXPORT;
      this.configurator.filtersData = filter;
      this.configurator.instance().refresh();

      if (this.configurator.isDetail() && filter && !isEmptyObject(filter) && Object.values(filter)[0] != null) {
        toolbarTableFormButtonsDisabling([SELECT, SEARCH, ADD, REFRESH, EXPORT], false, this._formUUID);
      }
    }
  }, {
    key: "unregister",
    value: function unregister() {
      this.tableInstance().dispose();
      this._loadPanel && this._loadPanel.dispose();

      this._tableInstance.remove();

      AppDispatcher.unregister(this.dispatcherToken);
    }
  }, {
    key: "prepareGoTo",
    value: function prepareGoTo(_ref5) {
      var _this4 = this;

      var customParameters = _ref5.customParameters,
          actionFormID = _ref5.actionFormID;
      return new Promise(function (resolve) {
        var params = JSON.parse(customParameters || '{}');
        var storageData = {};
        var lsKey = '';

        var ids = _this4.tableInstance().getSelectedRowKeys();

        Promise.all([loadFormFields(actionFormID), loadObjectData({
          filter: _defineProperty({}, _this4.configurator.keyField, ids),
          columns: [_this4.configurator.keyField, params.SourceAppObjectFieldName],
          objectName: _this4._objectName
        }), loadFormMetadata(actionFormID)]).then(function (resp) {
          var _filter2;

          var actionFormFields = resp[0];
          ids = _.uniq(_.pluck(resp[1], params.SourceAppObjectFieldName));
          var actionForm = resp[2];
          var formType = actionForm[Fields.Type],
              objectID = actionForm[Fields.ID];
          loadFilterFields({
            id: objectID,
            filter: (_filter2 = {}, _defineProperty(_filter2, Fields.FormID, objectID), _defineProperty(_filter2, "Name", params.DestAppObjectFilterName), _filter2)
          }).then(function (data) {
            var field, index;
            var filterField = data[0] || {};
            var objectFieldID = filterField[Fields.ObjectFieldID];

            if (formType === System.FORM_TYPE.TREE) {
              lsKey = "".concat(user.getUserID(), "-tv-").concat(actionFormID);
            } else if (formType === System.FORM_TYPE.LIST) {
              lsKey = "".concat(user.getUserID(), "-table-").concat(actionFormID);
            }

            storageData = getSSTableCols(lsKey);
            var settings = {};
            field = _.find(actionFormFields, function (item) {
              return item[Fields.ObjectFieldID] === objectFieldID;
            });

            if (!field) {
              var foreignFilter = getAddSSFilter(lsKey);
              foreignFilter[filterField.Name] = {
                filterValue: ids,
                realOperation: "isanyof"
              };
              setAddSSFilter(lsKey, foreignFilter);
              resolve({
                formID: actionFormID,
                type: formType
              });
              return;
            }

            settings.filterValue = ids.length ? ids : [];
            var _System$FIELD_TYPE = System.FIELD_TYPE,
                NUMBER = _System$FIELD_TYPE.NUMBER,
                TEXT = _System$FIELD_TYPE.TEXT;
            var fieldType = field[Fields.ObjectFieldID_FieldType];

            if ([NUMBER, TEXT].includes(fieldType)) {
              //'number', 'string'
              settings.realOperation = 'isanyof';
            } else {
              //boolean
              settings.realOperation = '=';
            }

            index = _.findIndex(storageData, function (s) {
              return s[Fields.ObjectFieldID] === objectFieldID;
            });

            if (~index) {
              storageData[index] = _objectSpread({}, storageData[index], settings);
            } else {
              settings.dataField = field.Name;
              storageData = [settings];
            }

            localStorage.setItem(lsKey, JSON.stringify(storageData));
            resolve({
              formID: actionFormID,
              type: formType
            });
          });
        });
      });
    }
  }, {
    key: "getKeysAfterClick",
    value: function getKeysAfterClick(_ref6) {
      var event = _ref6.event;
      var componentName = event.component.NAME;

      if (this.configurator.editMode === System.EDIT_MODE.CELL) {
        return [this.configurator.editingRowKey];
      }

      switch (componentName) {
        case System.DX_CONTROLS.dxButton:
          return this._tableInstance.dxDataGrid('getSelectedRowKeys');

        case 'dxContextMenu':
          return [event.itemData.rowId];
      }
    }
  }, {
    key: "deleteRows",
    value: function deleteRows(keys) {
      var _this5 = this;

      if (sharedData.formEditProcessed) return;
      sharedData.formEditProcessed = true;

      if (this.configurator.editMode !== System.EDIT_MODE.CELL) {
        if (sharedData.inlineEditing) {
          if (this.tableInstance().hasEditData()) {
            this.cancelRowChanges();
          }

          sharedData.formEditProcessed = null;
          this.configurator.inlineEditing(false);
          return;
        }
      }

      return new Promise(function (resolve) {
        DevExpress.ui.dialog.custom({
          message: Messages.Confirm.RowsDelete,
          title: Messages.Controls.Confirmation,
          buttons: [{
            text: Messages.Controls.Yes,
            onClick: function onClick() {
              return true;
            }
          }, {
            text: Messages.Controls.Cancel,
            onClick: function onClick() {
              return false;
            }
          }]
        }).show().then(function (result) {
          if (result) {
            _this5.internalDeleteRows(keys);
          }

          sharedData.formEditProcessed = null;
          resolve(result);
        });
      });
    }
  }, {
    key: "showTableModalFilter",
    value: function showTableModalFilter() {
      var lsKey = this.configurator.getLSName();
      var additional = {
        UUID: this._formUUID,
        lsKey: lsKey
      };
      additional.viewSource = this.configurator.viewSource;
      additional.formFilters = this.configurator._formFilters;
      loadForm({
        formID: this._formID,
        viewMode: System.VIEW_MODE.MODAL,
        type: System.FORM_TYPE.FILTER_MODAL,
        additionalData: additional
      });
    }
  }, {
    key: "showColumnChooserClicked",
    value: function showColumnChooserClicked() {
      this.configurator.instance().showColumnChooser();
    }
  }, {
    key: "selectionClicked",
    value: function selectionClicked(_ref7) {
      var selection = _ref7.selection;
      if (!selection) this.tableInstance().deselectAll();else {
        this.configurator.selectAll();
      }
    }
  }, {
    key: "showHeaderFilterBtnClicked",
    value: function showHeaderFilterBtnClicked(_ref8) {
      var formID = _ref8.formID;
      var ls = this.configurator.getLSName();

      var row = this._tableInstance.find('.dx-datagrid-filter-row');

      var rowFilter = JSON.parse(sessionStorage.getItem("".concat(ls, "-row-filter")) || '{}');
      var isEnabled = $('.show-header-row-filter', '#toolbar-' + formID).attr('data-enable');
      sessionStorage.setItem("".concat(ls, "-row-filter"), JSON.stringify({
        shown: Number(!rowFilter.shown)
      }));
      tbButtonsToggleAttrs(['show-header-row-filter'], !Boolean(isEnabled), this._formUUID);
      row.toggleClass('shown');
    }
  }, {
    key: "tableInstance",
    value: function tableInstance() {
      return this._tableInstance.dxDataGrid('instance');
    }
  }, {
    key: "editButtonEvent",
    value: function editButtonEvent(_ref9) {
      var _this6 = this;

      var formID = _ref9.formID,
          mode = _ref9.mode,
          event = _ref9.event;
      var editMode = this.configurator.editMode;
      var _System$FORM_EDIT_CRE = System.FORM_EDIT_CREATE_MODE,
          EDIT = _System$FORM_EDIT_CRE.EDIT,
          ADD = _System$FORM_EDIT_CRE.ADD,
          MULTI_EDIT = _System$FORM_EDIT_CRE.MULTI_EDIT;
      var _System$EDIT_MODE = System.EDIT_MODE,
          INLINE = _System$EDIT_MODE.INLINE,
          CELL = _System$EDIT_MODE.CELL;
      var table = this.configurator.instance();
      var selKeys = table.getSelectedRowKeys();
      var rowIndex = 0; //Если редактирование в строке и Insert - сохранить запись

      if (this.configurator.inlineEditing() && event.keyCode === 45) {
        this.saveRowChanges();
        sharedData.formEditProcessed = null;
        return;
      }

      if (editMode === INLINE && formID == null || this.configurator.isNestedObject() && ([INLINE, CELL].includes(editMode) || formID != null)) {
        if (this.configurator.isNestedObject() && formID != null) {
          showSnackBar({
            type: System.SNACKBAR_TYPES.Warning,
            message: Messages.Warning.EditNestedDataOnlyInInlineMode
          });
        }

        if (this.configurator.isNestedObject() && editMode === CELL && ADD !== mode) {
          sharedData.formEditProcessed = null;
          return;
        }

        this.configurator.updating = mode;
        this.configurator.inlineEditing(mode);

        if (EDIT === mode) {
          rowIndex = table.getRowIndexByKey(selKeys[0]);
        }

        this.configurator.rowCore.getRowData(mode).then(function (data) {
          _this6.configurator.startInlineEditing(rowIndex, data);
        });
      } else {
        if (formID == null || this.configurator.inlineEditing() || selKeys[0] == null && mode === EDIT) {
          sharedData.formEditProcessed = null;
          return;
        }

        var lastForm = FormStore.lastForm();

        if (lastForm && lastForm.formID === formID) {
          sharedData.formEditProcessed = null;
          return;
        }

        var parentRoute = location.hash.slice(1);
        if (parentRoute[parentRoute.length - 1] === '/') parentRoute = parentRoute.slice(0, -1);
        var url = createEditUrl({
          parentRoute: parentRoute,
          mode: mode,
          formID: formID,
          id: mode === MULTI_EDIT ? selKeys.join('&') : selKeys[0]
        });
        var hasParent = this._parentFormID != null;

        if (this.shouldOpenInNewAfterClick(event)) {
          //middle mouse button, LMK+Ctrl
          loadForm({
            formID: formID,
            type: System.FORM_TYPE.EDIT,
            mode: mode,
            rowID: mode === ADD ? null : mode === MULTI_EDIT ? selKeys.join('&') : selKeys[0],
            viewMode: System.VIEW_MODE.IN_NEW_WINDOW,
            formTableMode: hasParent,
            additionalData: hasParent ? this.configurator.filtersData : {},
            parentUUID: this._formUUID,
            newLocation: document.location.origin + document.location.pathname + "#".concat(url),
            afterChildClose: this.afterChildClose.bind(this)
          });
          sharedData.formEditProcessed = null;
        } else if (event.which !== 3) {
          //not RMK
          if (!hasParent) {
            router.navigateTo(url, false);
          }

          loadFormMetadata(formID).then(function (meta) {
            loadForm({
              formID: formID,
              type: System.FORM_TYPE.EDIT,
              mode: mode,
              rowID: mode === ADD ? null : mode === MULTI_EDIT ? selKeys.join('&') : selKeys[0],
              viewMode: !hasParent ? meta[Fields.ViewMode] : System.VIEW_MODE.MODAL,
              formTableMode: hasParent,
              additionalData: hasParent ? _this6.configurator.filtersData : {},
              parentUUID: _this6._formUUID
            });
          });
        }
      }
    }
  }, {
    key: "shouldOpenInNewAfterClick",
    value: function shouldOpenInNewAfterClick(event) {
      return event.which === 2 || event.which === 1 && event.ctrlKey;
    }
  }, {
    key: "afterChildClose",
    value: function afterChildClose(msg) {
      showSnackBar({
        type: System.SNACKBAR_TYPES.Success,
        message: msg
      });
      this.tableInstance().refresh();
      sharedData.formEditProcessed = null;
    }
  }, {
    key: "saveFilter",
    value: function saveFilter(lsColumns, addFilter) {
      var lsKey = this.configurator.getLSName();
      lsColumns.forEach(function (col) {
        if (isEmptyValue(col.filterValue)) delete col.filterValue;
      });
      setSSTableCols(lsKey, lsColumns);
      setAddSSFilter(lsKey, addFilter);
      d5TableFilterSaved({
        formUUID: this._formUUID,
        sender: System.FILTER_SENDERS.TABLE
      });
    }
  }, {
    key: "updateFilterRowEditor",
    value: function updateFilterRowEditor(_ref10) {
      var dataField = _ref10.dataField,
          realOperation = _ref10.realOperation,
          filterValue = _ref10.filterValue;
      var filterEditors = this.configurator.rowCore.filterEditors;

      if (filterEditors.has(dataField)) {
        var editor = filterEditors.get(dataField);
        editor.operation(realOperation);
        editor.setValue(filterValue);
      }
    }
  }, {
    key: "onFilterSaved",
    value: function onFilterSaved(_ref11) {
      var _this7 = this;

      var _ref11$sender = _ref11.sender,
          sender = _ref11$sender === void 0 ? {} : _ref11$sender,
          formEditUUID = _ref11.formEditUUID,
          _ref11$table = _ref11.table,
          table = _ref11$table === void 0 ? {} : _ref11$table;
      var lsKey = this.configurator.getLSName();
      var operChanged = false;
      var valChanged = false;
      var lsColumns = getSSTableCols(lsKey);
      var addFilter = getAddSSFilter(lsKey);
      var grid = this.tableInstance();
      this.configurator.updating = 'onFilterSaved';
      grid.beginUpdate();
      lsColumns.forEach(function (lsCol) {
        if (!lsCol.dataField) //groups
          return;
        var col = grid.columnOption(lsCol.dataField);
        var currentFilterValue = col.filterValue;
        var nextFilterValue = lsCol.filterValue;

        if (lsCol.hasOwnProperty('realOperation')) {
          if (!col.userData) {
            col.userData = {};
          }

          col.userData.realOperation = lsCol.realOperation;

          if (_this7.shouldOperationChange(nextFilterValue, lsCol.realOperation)) {
            operChanged = true;
          }

          grid.columnOption(lsCol.dataField, 'userData', col.userData);
        }

        if (JSON.stringify(currentFilterValue) !== JSON.stringify(nextFilterValue)) {
          grid.columnOption(lsCol.dataField, 'filterValue', nextFilterValue);
          valChanged = true;
        }
      });
      grid.endUpdate();

      if (sender !== System.FILTER_SENDERS.FORM_EDIT) {
        lsColumns.forEach(function (lsCol) {
          _this7.updateFilterRowEditor(lsCol);
        });
      }

      var addFilterChanged = this.addFilterChanged(addFilter);
      this.configurator._addFilter = addFilter;
      this.configurator.updating = false; //если valChanged значит таблица обновиться тут endUpdate()

      if ((operChanged || addFilterChanged) && !valChanged) {
        grid.refresh();
      }

      if (sender === System.FILTER_SENDERS.FORM || sender === System.FILTER_SENDERS.TABLE) {
        updateLayoutFilters(this._formUUID, System.FILTER_SENDERS.TABLE);
      }

      if (sender === System.FILTER_SENDERS.FORM_EDIT) formEditUpdateSubForm(formEditUUID, table);
    }
  }, {
    key: "addFilterChanged",
    value: function addFilterChanged(addFilter) {
      return JSON.stringify(addFilter) !== JSON.stringify(this.configurator._addFilter);
    }
  }, {
    key: "shouldOperationChange",
    value: function shouldOperationChange(nextFilterValue, realOperation) {
      var _System$FILTER_OPERAT = System.FILTER_OPERATIONS,
          isblank = _System$FILTER_OPERAT.isblank,
          isnotblank = _System$FILTER_OPERAT.isnotblank,
          isanyof = _System$FILTER_OPERAT.isanyof,
          isnotanyof = _System$FILTER_OPERAT.isnotanyof;
      return !isEmptyValue(nextFilterValue) || [isblank, isnotblank, isanyof, isnotanyof].includes(realOperation);
    }
  }, {
    key: "internalDeleteRows",
    value: function internalDeleteRows(rows) {
      var _this8 = this;

      var that = this;
      var ins = this.configurator.instance();
      ins.deselectRows(rows);
      var ObjectModel = Model.extend({
        initialize: function initialize() {
          this.object = that._objectName;
        },
        idAttribute: this.configurator.keyField
      });
      var models = rows.map(function (row) {
        return new ObjectModel(_defineProperty({}, _this8.configurator.keyField, row));
      });
      var coll = new Collection(models);
      coll.model = ObjectModel;
      coll.object = this._objectName;

      if (this.configurator.isNestedObject()) {
        try {
          this.repaintGrid({
            operation: 'delete',
            key: rows
          });

          if (this.configurator.editMode === System.EDIT_MODE.CELL) {
            var DEL = System.TOOLBAR_BTN_CLASSES.DEL;
            toolbarTableFormButtonsDisabling([DEL], true, this._formUUID);
            this.configurator.editingRowKey = null;
          } //таймаут нужен потому что таблица не успивает обновить датасурс и он получается пустой


          setTimeout(function () {
            return _this8.configurator.rowCore.sendNestedData();
          }, 100);
          showSnackBar({
            type: System.SNACKBAR_TYPES.Success,
            message: Messages.Message.Deleted
          });
          tbSetDefaultButtonsState(this._formUUID);
        } catch (e) {
          showSnackBar({
            type: System.SNACKBAR_TYPES.Error,
            message: e.message
          });
        }

        return;
      }

      coll.sync("delete", coll, {
        success: function success() {
          _this8.repaintGrid({
            operation: 'delete',
            key: rows
          });

          tbSetDefaultButtonsState(_this8._formUUID);
          showSnackBar({
            type: System.SNACKBAR_TYPES.Success,
            message: Messages.Message.Deleted
          });
        },
        error: function error(response) {
          showSnackBar({
            type: System.SNACKBAR_TYPES.Error,
            message: response.ResponseText
          });
        }
      });
    }
  }, {
    key: "refreshTable",
    value: function refreshTable() {
      var _this9 = this;

      if (this.configurator.isNestedObject()) {
        this.tableInstance().refresh();
        return;
      }

      setTimeout(function () {
        _this9.configurator.inlineEditing(false);

        formEditTableFormShowTable(false, _this9._formUUID);
        formEditTableFormShowTable(true, _this9._formUUID);
        tbSetDefaultButtonsState(_this9._formUUID);
      });
    }
    /**
     * @param {string} fieldName
     * @return {object|undefined}
     */

  }, {
    key: "getFieldByName",
    value: function getFieldByName(fieldName) {
      return _.find(this.viewSource, function (item) {
        return item[Fields.Name] === fieldName;
      });
    }
  }, {
    key: "hideButtonsPanel",
    value: function hideButtonsPanel() {
      var inst = this.tableInstance();
      inst.columnOption("".concat(System.SYSTEM_PREFIX, "buttons_panel"), 'd5AddRow', false);
      inst.columnOption("".concat(System.SYSTEM_PREFIX, "buttons_panel"), 'd5EditRowIndex', null);
      inst.columnOption("".concat(System.SYSTEM_PREFIX, "buttons_panel"), "visible", false);
    }
  }, {
    key: "saveRowChanges",
    value: function () {
      var _saveRowChanges = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this10 = this;

        var inst, rowKey, _inst, rowSourceData, respKey, respData, _ref13, columnRowData, mode;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                inst = this.tableInstance();

                this._tableInstance.find('.d5-field').map(function (key, field) {
                  if ($(field).data(System.DX_CONTROLS.dxNumberBox)) {
                    $(field).dxNumberBox('blur');
                  } else if ($(field).data(System.DX_CONTROLS.dxTextBox)) {
                    $(field).dxTextBox('blur');
                  } else if ($(field).data(System.DX_CONTROLS.dxDateBox)) {
                    $(field).dxDateBox('blur');
                  }
                });

                if (inst.hasEditData()) {
                  _context.next = 6;
                  break;
                }

                this.cancelRowChanges();
                _context.next = 43;
                break;

              case 6:
                _context.prev = 6;

                if (!this.configurator.saving) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                this.configurator.saving = true;
                rowKey = this.configurator.editingRowInfo[this.configurator.systemKeyField];
                _inst = this.configurator.instance();
                _context.next = 14;
                return this.configurator.onRowBeforeSave({
                  sourceRow: Configurator.columnDataToSourceData({
                    data: this.configurator.editingRowInfo,
                    viewSource: this.configurator.viewSource,
                    instance: _inst
                  }),
                  key: rowKey
                });

              case 14:
                rowSourceData = _context.sent;

                if (!(this.configurator.validateRow() && !isEmptyObject(rowSourceData))) {
                  _context.next = 35;
                  break;
                }

                if (!this.configurator.isNestedObject()) {
                  _context.next = 21;
                  break;
                }

                respKey = rowKey || createGuid();
                respData = rowSourceData;
                _context.next = 26;
                break;

              case 21:
                _context.next = 23;
                return this.submitRow(rowKey, rowSourceData);

              case 23:
                _ref13 = _context.sent;
                respKey = _ref13.respKey;
                respData = _ref13.respData;

              case 26:
                if (!respKey) {
                  _context.next = 35;
                  break;
                }

                showSnackBar({
                  type: System.SNACKBAR_TYPES.Success,
                  message: Messages.Success.Saved
                });
                _context.next = 30;
                return this.configurator.sourceDataToColumnData(respData);

              case 30:
                columnRowData = _context.sent;
                mode = this.configurator.inlineEditing();
                this.cancelRowChanges();

                if (this.configurator.isNestedObject()) {
                  this.repaintGrid({
                    operation: mode,
                    rowData: columnRowData,
                    key: respKey
                  });
                  setTimeout(function () {
                    _this10.configurator.rowCore.sendNestedData();

                    _this10.configurator.onRowAfterSave(respKey);
                  }, 100);
                } else {
                  _inst.refresh();

                  this.configurator.onRowAfterSave(respKey);
                }

                sharedData.formEditProcessed = null;

              case 35:
                this.configurator.saving = false;
                _context.next = 43;
                break;

              case 38:
                _context.prev = 38;
                _context.t0 = _context["catch"](6);
                this.configurator.saving = false;
                console.error(_context.t0.message, _context.t0.stack);
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: _context.t0.message
                });

              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 38]]);
      }));

      function saveRowChanges() {
        return _saveRowChanges.apply(this, arguments);
      }

      return saveRowChanges;
    }()
  }, {
    key: "submitRow",
    value: function () {
      var _submitRow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(rowKey, rowSourceData) {
        var _ref14, error, rest;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.configurator.rowCore.submitRow({
                  sourceData: rowSourceData,
                  key: rowKey
                });

              case 2:
                _ref14 = _context2.sent;
                error = _ref14.error;
                rest = _objectWithoutProperties(_ref14, ["error"]);

                if (!error) {
                  _context2.next = 10;
                  break;
                }

                this.configurator.saving = false;
                console.trace(error);
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: error
                });
                return _context2.abrupt("return", {});

              case 10:
                return _context2.abrupt("return", rest);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function submitRow(_x, _x2) {
        return _submitRow.apply(this, arguments);
      }

      return submitRow;
    }()
  }, {
    key: "repaintGrid",
    value: function repaintGrid(_ref15) {
      var operation = _ref15.operation,
          rowData = _ref15.rowData,
          key = _ref15.key;
      var inst = this.configurator.instance();
      var items = inst.getDataSource().items();
      var indexes = [];

      switch (operation) {
        case 'add':
          if (this.configurator.isNestedObject()) {
            rowData[this.configurator.systemKeyField] = key;
            inst.getDataSource().store().insert(rowData);
            inst.refresh();
            inst.selectRows([key], false);
            return;
          }

          inst.beginUpdate();
          items.splice(0, 0, rowData);
          inst.repaintRows([0]);
          inst.refresh();
          inst.selectRows([key], false);
          inst.endUpdate();
          break;

        case 'edit':
          var index = inst.getRowIndexByKey(key);
          Object.assign(inst.getVisibleRows()[index].data, rowData);
          inst.repaintRows([index]);
          inst.selectRows([key], false);
          break;

        case 'delete':
          if (!Array.isArray(key)) key = [key]; // Пока не удалять!
          // ins.beginUpdate();
          // let views = inst.getVisibleRows();
          // for (let i = 0; i < key.length; ++i) {
          //     indexes.push(inst.getRowIndexByKey(key[i]));
          //     let index = views.findIndex(item => item.key === key[i]);
          //     views.splice(index, 1);
          // }
          // inst.repaintRows(indexes);
          // ins.endUpdate();

          inst.beginUpdate();
          this.resetTableScroll();

          for (var i = 0; i < key.length; ++i) {
            inst.deleteRow(inst.getRowIndexByKey(key[i]));
            inst.refresh();
          }

          inst.endUpdate();
          break;
      }
    }
  }, {
    key: "cancelRowChanges",
    value: function cancelRowChanges() {
      var inst = this.tableInstance();
      inst.beginUpdate();
      if (this.configurator.inlineEditing()) inst.cancelEditData();
      this.hideButtonsPanel();
      inst.endUpdate();
      this.configurator.inlineEditing(false);
    }
  }, {
    key: "initTable",
    value: function initTable() {
      var _this11 = this;

      var ids = Object.keys(_.groupBy(this.viewSource, Fields.ID));
      var filterIDs = Object.keys(_.groupBy(this._formFilters, Fields.ID));
      Promise.all([loadFormMetadata(this._formID), loadFormGroups({
        formID: this._formID,
        groupType: 4
      }), loadUserFunctions(ids), loadFormFilterFieldEvents(filterIDs)]).then(function (data) {
        var metadata = data[0];
        var groups = data[1];
        var fieldEvents = data[2];
        var filterEvents = data[3];
        _this11._objectName = metadata[Fields.ObjectID_Name];
        _this11._loadPanel = _this11.createLoader();
        toolbarTableSetObjectName(_this11._formUUID, _this11._objectName);

        if (!_this11._parentFormID) {
          sideDrawerListItemActivate(_this11._formID);
          changeDocumentTitle(metadata[Fields.Title]);
        }

        _this11.configurator = new Configurator({
          metadata: metadata,
          element: _this11._tableInstance,
          formUUID: _this11._formUUID,
          formID: _this11._formID,
          parentFormID: _this11._parentFormID,
          filtersData: _this11._filtersData,
          userEvents: fieldEvents,
          cancelRowChanges: _this11.cancelRowChanges,
          saveRowChanges: _this11.saveRowChanges,
          groups: groups,
          popupInst: _this11.popupInst,
          viewSource: _this11.viewSource,
          requestColumns: _this11.requestColumns,
          tableData: _this11.tableData,
          relationType: _this11.relationType,
          parentUUID: _this11._parentUUID,
          masterObjKeyFieldName: _this11._masterObjKeyFieldName,
          detailObjKeyFieldName: _this11._detailObjKeyFieldName,
          owner: _this11._owner,
          formFilters: _this11._formFilters,
          loadPanel: _this11._loadPanel,
          filterEvents: filterEvents,
          dataContextMenu: _this11.dataContextMenu
        });

        _this11.configurator.buildConfig().then(function (config) {
          _this11.configurator.updating = false;

          _this11._tableInstance.dxDataGrid(config);
        });
      });
    }
    /**
     * @param customParameters
     * @param actionFormID
     * @return {Promise<object|string>}
     */

  }, {
    key: "getReport",
    value: function getReport(_ref16) {
      var _this12 = this;

      var customParameters = _ref16.customParameters,
          actionFormID = _ref16.actionFormID;
      var parseParameters = JSON.parse(customParameters);
      var parameterFieldName = parseParameters[Fields.ParameterFieldName];
      var isShowForm = actionFormID != null; // 1.Если это отчет без формы(actionFormID = null), то ReportURL является полной ссылкой на отчет.
      // 2.Если это отчет с формой(actionFormID != null), то ReportURL - это часть урла.
      //  Сам урл нам нужно построить по формуле domain + ReportURL + host= + domain + params

      var parseUrl = function parseUrl(data) {
        var reportURL = parseParameters[Fields.ReportURL];
        var fieldsStr = '';
        var url = new URL(reportURL);
        var hostStr = !url.search ? 'host=' : '&host=';

        if (url.href.lastIndexOf('?') !== url.href.length - 1 && !url.search) {
          reportURL += '?';
        }

        _.each(data, function (item, iteratee) {
          if (item[parameterFieldName]) iteratee === 0 ? fieldsStr += item[parameterFieldName] : fieldsStr += ',' + item[parameterFieldName];
        });

        return reportURL + hostStr + document.domain + '&' + parameterFieldName + '=' + decodeURI(fieldsStr);
      };

      var createReportData = function createReportData(data) {
        return _defineProperty({}, parameterFieldName, data.map(function (item) {
          return item[parameterFieldName];
        }));
      };

      return new Promise(function (resolve) {
        var ids = _this12.configurator.instance().getSelectedRowKeys();

        loadObjectData({
          filter: _defineProperty({}, _this12.configurator.keyField, ids),
          columns: [_this12.configurator.keyField, parameterFieldName],
          objectName: _this12._objectName
        }).then(function (resp) {
          if (isShowForm) {
            resolve({
              data: createReportData(resp),
              reportUrl: parseParameters[Fields.ReportURL],
              actionFormID: actionFormID
            });
          } else {
            resolve(parseUrl(resp));
          }
        });
      });
    }
  }, {
    key: "clearQuickFilters",
    value: function clearQuickFilters() {
      var _this13 = this;

      var lsKey = this.configurator.getLSName();
      var lsColumns = getSSTableCols(lsKey);
      DevExpress.ui.dialog.custom({
        message: Messages.Confirm.ClearQuickFilters,
        title: Messages.Controls.Confirmation,
        buttons: [{
          text: Messages.Controls.Yes,
          onClick: function onClick() {
            return true;
          }
        }, {
          text: Messages.Controls.Cancel,
          onClick: function onClick() {
            return false;
          }
        }]
      }).show().then(function (result) {
        if (result) {
          var _formFilters = _this13.configurator._formFilters;
          var reqFilters = {};

          _formFilters.filter(function (f) {
            return f[Fields.IsRequired];
          }).forEach(function (f) {
            reqFilters[f[Fields.ObjectFieldID]] = f[Fields.ObjectFieldID];
          });

          lsColumns.forEach(function (col) {
            if (reqFilters.hasOwnProperty(col.ObjectFieldID)) return;
            if (col.hasOwnProperty('filterValue')) col.filterValue = null;
            if (col.hasOwnProperty('filterValues')) col.filterValues = null;
          });
          setSSTableCols(lsKey, lsColumns);

          _this13.onFilterSaved({
            sender: System.FILTER_SENDERS.TABLE
          });
        }
      });
    }
  }, {
    key: "resetTableScroll",
    value: function resetTableScroll() {
      this.tableInstance().getScrollable().scrollTo(0);
    }
  }, {
    key: "refreshTableAfterSubmittedForm",
    value: function refreshTableAfterSubmittedForm(_ref18) {
      var _this14 = this;

      var mode = _ref18.mode;
      this.tableInstance().refresh().done(function () {
        if (mode === System.FORM_EDIT_CREATE_MODE.ADD) _this14.resetTableScroll();
      });
    }
  }, {
    key: "createLoader",
    value: function createLoader() {
      var loaderSelector = "#table-loader-".concat(createTableID(this._formID, this._parentFormID)),
          nodeSelector = "#".concat(this._tableInstance.attr('id'));
      return new CustomLoader({
        loaderSelector: loaderSelector,
        nodeSelector: nodeSelector
      });
    }
  }]);

  return D5TableStoreClass;
}(StoreClass);

export default D5TableStoreClass;